var map = {
	"./airtm-dark.png": "a8b9",
	"./arch-dark.png": "966a",
	"./bbva-dark.png": "da01",
	"./bitbox-dark.png": "5d03",
	"./bitpanda-dark.png": "878a",
	"./bitstamp-dark.png": "dbda",
	"./bittrex-dark.png": "858f",
	"./bitvavo-dark.png": "020d",
	"./buxzero-dark.png": "d0c1",
	"./caixabank-dark.png": "0faa",
	"./criptan-dark.png": "a7cc",
	"./cryptocom-dark.png": "ca31",
	"./degiro-dark.png": "5144",
	"./etoro-dark.png": "e3e5",
	"./etrade-dark.png": "d84f",
	"./exante-dark.png": "a6f6",
	"./freedom24-dark.png": "b9a2",
	"./gemini-dark.png": "917e",
	"./hapi-dark.png": "ed80",
	"./heytrade-dark.png": "e2ce",
	"./ibkr-dark.png": "4d01",
	"./ing-dark.png": "ca30",
	"./ledger-dark.png": "86ed",
	"./myinvestor-dark.png": "9124",
	"./n26-dark.png": "a9b7",
	"./openbank-dark.png": "fe3b",
	"./perCapital-dark.png": "4521",
	"./renta4-dark.png": "f759",
	"./revolut-dark.png": "3f9a",
	"./sabadell-dark.png": "36b6",
	"./scalable-dark.png": "b5f2",
	"./tastytrade-dark.png": "925a",
	"./tradeRepublic-dark.png": "e961",
	"./trading212-dark.png": "98f9",
	"./xtb-dark.png": "8da5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f52";